import type { eventDetailResource, eventResource } from '@porotutu/api/features/crm/events/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { EVENTS } from '@/api/keys'
import type { CrmEventSort, EventCategory } from '../vocabulary'

export type Event = ReturnType<typeof eventResource>

export type EventDetail = ReturnType<typeof eventDetailResource>

export type EventPage = { data: Event[]; meta: ListMeta }

export type EventListQuery = ListQuery<CrmEventSort, never> & {
  customer_id?: string
  category?: EventCategory
}

export const eventsQuery = (query: EventListQuery) =>
  queryOptions({
    queryKey: [...EVENTS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.events.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const eventQuery = (id: string) =>
  queryOptions({
    queryKey: [...EVENTS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.events({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<EventListQuery>('/api/v1/crm/events/export', {
  always: ['customer_id'],
  viewed: ['category', 'search'],
})
